import { isLowerCase, isUpperCase, isPromise, stringifyRecursive } from './utils'

// helper data load functions that fetch data and sets state. caller to handle exceptions
export const simulateAPICall = (jsonData) => new Promise((resolve) => setTimeout(() => resolve(jsonData), 1000));

export const entityProxy = (obj) => {
    if (typeof obj == 'undefined') {
        const err = "Undefined proxy target"
        console.error(err)
        window.alert(err)
        return null
    }
    else if (isPromise(obj)) {
        const err = "Received a promise as input parameter"
        console.error(err)
        window.alert(err)
        return null
    }
    const allowed = { prototype: true }
    return new Proxy(
        obj,
        {
            get(target, property) {
                if (property in target || typeof property == 'symbol') {
                    return target[property];
                }
                if (typeof property == 'string') {
                    if (property[0] == "_" || property in allowed) {
                        return target[property]
                    }
                    else if (property === 'then') {
                        return (fulfill, reject) => {
                            try {
                                fulfill(target);
                            } catch (error) {
                                reject(error);
                            }
                        }
                    }
                    else if (property === 'toJSON') {
                        return stringifyRecursive(target, { collapseArrays: false, disallowCycles: true, showTabs:false })
                    }
                    else if (isUpperCase(property[0])) {
                        let splat = property.split('')
                        splat[0] = splat[0].toLowerCase()
                        property = splat.join('')
                        if (property in target) {
                            console.error("Erroneous PascalCase property name \"".concat(property).concat("\" detected"))
                            return target[property]
                        }
                        splat[0] = splat[0].toUpperCase()
                        property = splat.join('')
                    }
                    else if (isLowerCase(property[0])) {
                        let err
                        if (target.debugInfo) {
                            err = `Undefined property ${property} in object with debug string ${target.debugInfo}. See console.`
                        }
                        else {
                            err = "Undefined property \"".concat(property).concat("\"")
                        }
                        console.error(err)
                        console.trace()
                        console.log(target)
                        //window.alert(err)
                        return null
                    }
                }
                else {
                    console.log("Undefined property ".concat(property.toString()).concat(" has type ").concat(typeof property))
                }
                console.trace()
                throw new Error(`Undefined property '${property.toString()}' also does not exist in camel case`);
            }
        }
    )
}

export const printProxy = (proxy) => {
    if (Array.isArray(proxy)) {
        for (let i = 0; i < proxy.length; i++) {
            printProxy(proxy[i])
        }
    }
    else {
        console.log(proxy.target)
    }
}